const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const SETTINGS = {
    UPDATE_PERSONAL_INFORMATION: `${API_BASE_URL}/users/settings/personal-information/`,
    UPDATE_EMAIL: `${API_BASE_URL}/users/settings/email/`,
    UPDATE_PASSWORD: `${API_BASE_URL}/users/settings/password/`,
};

export default SETTINGS;